import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Loader, Dimmer } from "semantic-ui-react";
import moment from "moment";
import axios from "axios";
import { formatMoneda } from "../../util/varios";
import { Mensaje, MensajeSiNo } from "../../components/mensajes";
import useTableScroll from "../useTableScroll";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import { RegistrarPago } from "./modalRegistrarPago";

const RegistrarPagoNotadeEntrega = (props) => {
  const op = require("../../../public/modulos/datos");
  const token = sessionStorage.getItem("jwtToken");
  const anioActu = JSON.parse(sessionStorage.getItem("anioactu"));
  const idVendedor = JSON.parse(sessionStorage.getItem("idagente"));
  const afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
  const accbtncntxcobrar = JSON.parse(
    sessionStorage.getItem("accbtncntxcobrarc")
  );
  const cmbCedula = ["J", "V", "G", "P"];
  const headCells = [
    { label: "COD-PRODUCTO", textAlign: "center", width: "60px" },
    { label: "PRODUCTO", textAlign: "center", width: "160px" },
    { label: "CANTIDAD", textAlign: "center", width: "20px" },
    { label: "PRECIO UNI.", textAlign: "center", width: "50px" },
    { label: "UND. ALT.", textAlign: "center", width: "50px" },
    { label: "%IVA", textAlign: "center", width: "50px" },
    { label: "MONTO IVA", textAlign: "center", width: "50px" },
    { label: "SIN IVA", textAlign: "center", width: "50px" },
  ];

  const txtIdNotaEntrega = useRef();
  const cmbTipo = useRef();
  const txtFecha = useRef();
  const txtId = useRef([]);
  const txtCantidad = useRef([]);
  const txtAbono = useRef();
  const btnCancela = useRef();
  const txtSaldo = useRef();
  const cmbRif = useRef();
  const txtRif = useRef();
  const txtSubTotal = useRef();
  const txtDescuento = useRef();
  const txtTotIva = useRef();
  const txtTotal = useRef();
  const txtIdPedido = useRef();
  const cmbMoneda = useRef();
  const txtContado = useRef();
  const txtCredito = useRef();
  const txtFechaVencimiento = useRef();
  const [actcredit, setActcredit] = useState(0);
  const [operacion, setOperacion] = useState(0);
  const [selectp, setSelectp] = useState(0);
  const [numNota, setNumNota] = useState("");
  const [esretencion, setEsretencion] = useState(0);
  const [numPedido, setNumPedido] = useState("");
  const [cedRif, setCedRif] = useState("");
  const [nomVendedor, setNomVendedor] = useState("");
  const [actanticipo, setActanticipo] = useState(0);
  const [idCliente, setIdCliente] = useState("");
  const [nomCliente, setNomCliente] = useState("");
  const [dirCliente, setDirCliente] = useState("");
  const [mostrar, setMostrar] = useState(false);
  const [numfact, setNumfact] = useState("");
  const [records, setRecords] = useState([]);
  const [idfact, setIdfact] = useState(0);
  const [combomoneda, setCombomoneda] = useState([]);
  const [activate, setActivate] = useState(false);
  const [xiva, setXiva] = useState(0.0);
  const [montoiva, setMontoiva] = useState(0.0);
  const [monto, setMonto] = useState(0.0);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [moneda, setMoneda] = useState({
    idmoneda: "1",
    descripcion: "BOLIVARES",
    simbolo: "Bs",
    predeterminada: true,
    subpredeterminada: false,
    valormoneda: 1.0,
  });
  const [totales, setTotales] = useState({
    subtotal: 0.0,
    descuento: 0.0,
    exento: 0.0,
    sujeto: 0.0,
    iva: 16.0,
    totaliva: 0.0,
    total: 0.0,
  });

  const { TblContainer, TblHead } = useTableScroll(headCells);

  const blanquear = () => {
    setMostrar(false);
    setActivate(false);
    setOperacion(0);
    setActcredit(0);
    setActanticipo(0);
    setSelectp(0);
    cmbMoneda.current.selectedIndex = -1;
    txtContado.current.checked = true;
    setMoneda({
      idmoneda: "1",
      descripcion: "BOLIVARES",
      simbolo: "Bs",
      predeterminada: false,
      valormoneda: 1.0,
    });
    setRecords([]);
    txtIdNotaEntrega.current.value = "";
    txtFechaVencimiento.current.value = "";
    txtIdNotaEntrega.current.setAttribute("disabled", true);
    cmbTipo.current.selectedIndex = -1;
    cmbRif.current.selectedIndex = -1;
    txtRif.current.value = "";
    setNumPedido("");
    setNumNota("");
    setNomCliente("");
    setDirCliente("");
    setNomVendedor("");
    setCedRif("");
    txtFecha.current.value = "";
    txtSubTotal.current.value = "";
    txtTotIva.current.value = "";
    txtTotal.current.value = "";
    txtDescuento.current.value = "";
    txtSaldo.current.value = "";
    txtAbono.current.value = "";
  };

  const handleCloseSi = () => {
    setActivate(false);
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const seleccionarCliente = (rif, tecla) => {
    let campos = "*";
    let nomtab = "agente";
    let nomid = "idagente";
    let nomid2 = "cliente";
    let id = rif;
    let endpoint = "";

    endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=${nomid2}&id2=true`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {

            if (response.data.agenteretencion === true) {
              setEsretencion(1);
            } else {
              setEsretencion(0);
            }
            cmbRif.current.value = response.data.rif.trim().substring(0, 1);
            txtRif.current.value = response.data.rif.trim().substring(1, 10);
            setIdCliente(response.data.idagente);
            setNomCliente(response.data.nombre);
            setDirCliente(response.data.direccion.trim());
            if (tecla === 13) {
              txtFecha.current.focus();
            }
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "No existe un cliente con este codigo",
              icono: "informacion",
            });
            txtRif.current.value = "";
            cmbRif.current.selectedIndex = -1;
            if (tecla === 13) {
              txtRif.current.focus();
            }
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarVendedor = (idv) => {
    let campos = "*";
    let nomtab = "agente";
    let nomid = "idagente";
    let nomid2 = "vendedor";
    let id = idv === null ? "0" : idv;
    let endpoint = "";

    endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=${nomid2}&id2=true`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            setCedRif(response.data.rif);
            setNomVendedor(response.data.nombre);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "El usuario no tiene un vendedor asociado",
              icono: "informacion",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarMoneda = (id) => {
    let campos = "*";
    let nomtab = "moneda";
    let nomid = "idmoneda";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.idmoneda > 0) {
            setMoneda(response.data);
            let datamoneda = [];

            datamoneda.push({
              descripcion: response.data.descripcion,
              idmoneda: response.data.idmoneda,
              predeterminada: response.data.predeterminada,
              simbolo: response.data.simbolo,
              subpredeterminada: response.data.subpredeterminada,
              valormoneda: response.data.valormoneda,
            });

            setCombomoneda(datamoneda);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarRegistro = (id) => {
    let campos = "*";
    let nomtab = "notaentrega";
    let nomid = "idnotaentrega";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            txtIdNotaEntrega.current.value = response.data.idnotaentrega;
            setIdfact(response.data.idnotaentrega);
            setNumfact(response.data.numnotaentrega);

            if (response.data.credito !== false) {
              txtCredito.current.checked = true;
              txtContado.current.checked = false;
              txtFechaVencimiento.current.value = moment(
                response.data.fechavencimiento
              ).format("YYYY-MM-DD");
            } else {
              txtCredito.current.checked = false;
              txtContado.current.checked = true;
            }

            if (
              response.data.numpedido === "" ||
              response.data.numpedido === null
            ) {
              if (response.data.tipo === "NE") {
                cmbTipo.current.value = "1";
              } else if (response.data.tipo === "NO") {
                cmbTipo.current.value = "3";
              }
            } else {
              setSelectp(1);
              cmbTipo.current.value = "2";
              setNumPedido(response.data.numpedido);
              txtIdPedido.current.value = response.data.numpedido;
            }

            txtFecha.current.value = moment(response.data.fecha).format(
              "YYYY-MM-DD"
            );
            setNumNota(response.data.numnotaentrega);
            setTotales({
              subtotal: parseFloat(response.data.totalmonto) - parseFloat(response.data.totaliva),
              descuento: response.data.totaldescuento,
              exento: response.data.totalexento,
              sujeto: response.data.totalsujeto,
              iva: 16.0,
              totaliva: response.data.totaliva,
              total: response.data.totalmonto,
            });

            let tosaldo = 0.0;
            tosaldo =
              parseFloat(response.data.totalmonto) - parseFloat(props.abono);

            txtAbono.current.value = formatMoneda(
              props.abono.toString().replace(",", "").replace(".", ","),
              ",",
              ".",
              2
            );
            txtSaldo.current.value = formatMoneda(
              tosaldo.toString().replace(",", "").replace(".", ","),
              ",",
              ".",
              2
            );

            setMonto(tosaldo);
            setXiva(16.0);
            setMontoiva(response.data.totaliva);
            seleccionarCliente(response.data.idcliente, 46);
            seleccionarVendedor(response.data.idvendedor);
            seleccionarMoneda(response.data.idmoneda);
            seleccionarDetalle(id);
            if (operacion === 2) {
              setTimeout(() => txtFecha.current.focus(), 200);
            } else {
              setTimeout(() => btnCancela.current.focus(), 200);
            }
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "ID no existe.",
              icono: "informacion",
            });
            txtIdNotaEntrega.current.value = "";
            txtIdNotaEntrega.current.focus();
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarDetalle = (id) => {
    let nomtab1 = "notaentregadetalle";
    let nomtab2 = "notaentrega";
    let nomid = "idnotaentrega";
    let endpoint = `${op.conexion}/api/inventario/seleccionarnotaentregadetordenes?id=${id}&nomtab1=${nomtab1}&nomtab2=${nomtab2}&nomid=${nomid}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            var prod = [];
            let uni = [];
            let precio = 0.0;
            let tasa = 0.0;

            for (let i = 0; i < response.data.length; i++) {
              if (
                parseInt(response.data[i].idunidadalterna) === 0 ||
                response.data[i].idunidadalterna === null
              ) {
                uni = [
                  {
                    idunidad: response.data[i].idunidadmedida,
                    descripcion: response.data[i].servicio === true ? "SERVICIO" : response.data[i].descripcionuni,
                    tipo: "medida",
                  },
                ];
              } else {
                if (response.data[i].tipounidad === 0) {
                  uni = [
                    {
                      idunidad: response.data[i].idunidadmedida,
                      descripcion: response.data[i].servicio === true ? "SERVICIO" : response.data[i].descripcionuni,
                      tipo: "medida",
                    },
                    {
                      idunidad: response.data[i].idunidadalterna,
                      descripcion: response.data[i].servicio === true ? "SERVICIO" : response.data[i].descripcionunialt,
                      tipo: "alterna",
                    },
                  ];
                } else {
                  uni = [
                    {
                      idunidad: response.data[i].idunidadalterna,
                      descripcion: response.data[i].servicio === true ? "SERVICIO" : response.data[i].descripcionunialt,
                      tipo: "alterna",
                    },
                    {
                      idunidad: response.data[i].idunidadmedida,
                      descripcion: response.data[i].servicio === true ? "SERVICIO" : response.data[i].descripcionuni,
                      tipo: "medida",
                    },
                  ];
                }
              }

              let montoiva =
                (response.data[i].punitario * response.data[i].iva) / 100;
              //montoiva = Math.round(montoiva * 100) / 100;

              let cantie = response.data[i].cantidade;
              let cantiea = 0.0;
              if (response.data[i].tipounidad === 0) {
                if (response.data[i].tipofactor === "1") {
                  cantie = parseFloat(
                    response.data[i].cantidade / response.data[i].valorfactor
                  );
                  //cantie = Math.round(cantie * 100) / 100;
                  cantie = Math.trunc(cantie);

                  cantiea = parseFloat(
                    response.data[i].cantidad * response.data[i].valorfactor
                  );
                  cantiea = Math.trunc(cantiea);
                }
              } else {
                if (response.data[i].tipofactor === "0") {
                  cantie = parseFloat(
                    response.data[i].cantidade / response.data[i].valorfactor
                  );
                  //cantie = Math.round(cantie * 100) / 100;
                  cantie = Math.trunc(cantie);

                  cantiea = parseFloat(
                    response.data[i].cantidad * response.data[i].valorfactor
                  );
                  cantiea = Math.trunc(cantiea);
                }
              }

              prod.push({
                idproducto: response.data[i].idproducto,
                codigo: response.data[i].codproducto,
                cantidad: response.data[i].cantidad,
                cantidadE:
                  parseFloat(cantie) + parseFloat(response.data[i].cantidad),
                cantidadEA:
                  parseFloat(response.data[i].cantidade) + parseFloat(cantiea),
                nombrecorto: response.data[i].nombrecorto,
                precio: response.data[i].punitario,
                precious: response.data[i].punitario,
                preciobs: response.data[i].punitariobs,
                iva: response.data[i].iva,
                ivaventa: response.data[i].ivaventa,
                montoiva: response.data[i].cantidad * montoiva,
                descuento: response.data[i].descuento,
                total: response.data[i].cantidad * response.data[i].punitario,
                unidad: uni,
                idunidadmedida: response.data[i].idunidadmedida,
                idunidadalterna: response.data[i].idunidadalterna,
                costocalculado: response.data[i].costocalculado,
                costocalculadoalter: response.data[i].costocalculadoalter,
                utipreciomaxi: response.data[i].utipreciomaxi,
                utipreciomaxialter: response.data[i].utipreciomaxialter,
                tipounidad: response.data[i].tipounidad,
                valormoneda: response.data[i].valormoneda,
                idmoneda: response.data[i].idmoneda,
                tipofactor: response.data[i].tipofactor,
                valorfactor: response.data[i].valorfactor,
              });
            }
            setRecords(prod);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const onChangeValidar = () => {
    if (
      accbtncntxcobrar &&
      accbtncntxcobrar.toString().substring(1, 2) === "1"
    ) {
      seleccionarCredito(idCliente);
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Notificación.",
        texto: "¡No Posee Permiso para Realizar esta Acción!",
        icono: "error",
      });
    }
  };

  const imprimirNotaEntrega = () => {
    if (
      accbtncntxcobrar &&
      accbtncntxcobrar.toString().substring(4, 5) === "1"
    ) {
      let debt = 0;
      if (txtIdNotaEntrega.current.value !== "") {
        let idnot = txtIdNotaEntrega.current.value;

        let nota = JSON.parse(sessionStorage.getItem("tiporepnotaentrega"));
        var reporte = nota.toString() === 'HOJA' ? "ReportNotaEntrega" : "ReportNotaEntregaMedium";

        window.open(
          op.reportes +
          "/ventas?afiliado=" +
          afiliado +
          "&reporte=" +
          reporte +
          "&idnota=" +
          idnot,
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
        );
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "¡ Seleccione la nota de Entrega !",
          icono: "informacion",
        });
        debt = 1;
      }

      if (debt === 1) {
        txtIdNotaEntrega.current.focus();
      }
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Notificación.",
        texto: "¡No Posee Permiso para Realizar esta Acción!",
        icono: "error",
      });
    }
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
  };

  const renderizar = () => {
    props.onRenderizar();
    props.onHideCancelar();
  };

  const seleccionarCredito = (id) => {
    let endpoint = "";

    endpoint = `${op.conexion}/api/consulta/seleccionarcredito?idcliente=${id}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            let montototal = 0.0;

            for (let i = 0; i < response.data.length; i++) {
              montototal =
                parseFloat(montototal) +
                parseFloat(response.data[i].totalmonto);
            }

            if (montototal > 0 && props.anticipo > 0) {
              setMostrar(true);
              setActcredit(1);
              setActanticipo(1);
            } else {
              if (props.anticipo > 0) {
                setMostrar(true);
                setActcredit(0);
                setActanticipo(1);
              } else if (montototal > 0) {
                setMostrar(true);
                setActcredit(1);
                setActanticipo(0);
              } else {
                setMostrar(true);
                setActcredit(0);
                setActanticipo(0);
              }
            }
            setActivate(false);
          } else {
            if (props.anticipo > 0) {
              setMostrar(true);
              setActcredit(0);
              setActanticipo(1);
            } else {
              setMostrar(true);
              setActcredit(0);
              setActanticipo(0);
            }
            setActivate(false);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      size="xl"
      backdrop="static"
      keyboard={false}
      onShow={() => {
        if (props.ope === 1) {
          if (cmbTipo) {
            cmbTipo.current.selectedIndex = -1;
          }
          seleccionarRegistro(props.idnot);
        }
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <div className="fw-bold text-light">
          <h3>Nota de Entrega</h3>
        </div>
        <button
          ref={btnCancela}
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div style={{ height: "100%", width: "100%" }}>
          <div className="row col-md-12" style={{ margin: 0 }}>
            <div className="col-md-12 row border-azul mx-auto rounded py-1">
              <div className="col-md-12 row mx-auto d-flex justify-content-between mb-1">
                <div
                  className="colfull col-pd-180 mb-1"
                  style={{ fontSizeAdjust: "0.6" }}
                >
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      CODIGO:
                    </label>
                    <input
                      type="text"
                      disabled
                      autoComplete="off"
                      ref={txtIdNotaEntrega}
                      name="idnotaentre"
                      className="form-control fs-6"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                </div>

                <div
                  className="colfull col-pd-380 mb-1 px-0"
                  style={{ fontSizeAdjust: "0.6" }}
                >
                  <label className="text-left">
                    NOTA ENTREGA N°:{" "}
                    <span className="col fw-bold text-danger">
                      &nbsp;{numNota}
                    </span>
                  </label>
                </div>

                <div
                  className="colfull col-pd-180 mb-1 mr-auto px-1"
                  style={{ fontSizeAdjust: "0.6" }}
                >
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      TIPO:
                    </label>
                    <select
                      disabled
                      ref={cmbTipo}
                      className="form-select form-select-sm"
                      aria-label=".form-select-sm example"
                      name="tipo"
                      id="tipo"
                    >
                      <option value="1">NUEVO</option>
                      <option value="2">POR PEDIDO</option>
                      <option value="3">OBSEQUIO</option>
                    </select>
                  </div>
                </div>

                <input type="hidden" ref={txtIdPedido} />

                {selectp === 1 ? (
                  <div
                    className="colfull col320"
                    style={{ fontSizeAdjust: "0.6" }}
                  >
                    <label className="text-right">
                      PEDIDO N°:{" "}
                      <span className="col fw-bold text-danger">
                        &nbsp;{numPedido}
                      </span>
                    </label>
                  </div>
                ) : (
                  ""
                )}
              </div>

              <div
                className="col-md-12 row mx-auto mb-1"
                style={{ fontSizeAdjust: "0.6" }}
              >
                <div className="colfull col-pd-290 mb-3">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      TIPO MONEDA:
                    </label>
                    <select
                      className="form-control form-control-sm fw-bold text-center"
                      disabled
                      ref={cmbMoneda}
                    >
                      {combomoneda &&
                        combomoneda.map((item, index) => (
                          <option key={index} value={index}>
                            {" "}
                            {`${item.descripcion} ${item.simbolo
                              } ${formatMoneda(
                                item.valormoneda
                                  .toString()
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )}`}{" "}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>

                <div className="colfull col270">
                  <div className="mt-14m mr-auto col-pd-260 px-0">
                    <fieldset className="row col-sm-12 border-azul rounded mb-1">
                      <legend
                        className="float-none m-0 w-auto"
                        style={{ fontSize: "14px" }}
                      >
                        TIPO VENTA:
                      </legend>

                      <div className="col-5 mr-auto">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            disabled
                            name="contado"
                            ref={txtContado}
                            value="1"
                            defaultChecked={true}
                            id="contado"
                            type="radio"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="exampleRadi4"
                          >
                            Contado
                          </label>
                        </div>
                      </div>

                      <div className="col-5 ml-auto">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            disabled
                            name="contado"
                            ref={txtCredito}
                            value="2"
                            id="contado"
                            type="radio"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="exampleRadi5"
                          >
                            Crédito
                          </label>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                </div>

                <div className="col-pd-300 mr-auto px-1">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      FECHA/VENCIMIENTO:
                    </label>
                    <input
                      autoComplete="off"
                      disabled
                      type="date"
                      ref={txtFechaVencimiento}
                      className="form-control text-uppercase fs-6"
                      //value={moment(fechav).format("YYYY-MM-DD")}
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      name="fechav"
                    />
                  </div>
                </div>

                <div className="col-pd-200 ml-auto">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      FECHA:
                    </label>
                    <input
                      autoComplete="off"
                      type="date"
                      disabled
                      ref={txtFecha}
                      className="form-control fs-6 text-uppercase"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      name="fecha"
                    />
                  </div>
                </div>
              </div>

              <div
                className="colfull1070 colfull60p mx-auto mb-1 "
                style={{ fontSizeAdjust: "0.6" }}
              >
                <div className="col-md-12 mx-auto row border-azul rounded py-2">
                  {/*<span className='fw-bold'>Datos del Cliente <a style={{ pointerEvent: 'cursor', visibility: visible === 'hidden' ? 'visible' : 'hidden', fontSize: '12px' }} className='text-info rounded-circle' title='Buscar Cliente'><i class=" fas fa-search"></i></a> </span>*/}
                  <span className="fw-bold mb-1">Datos del Cliente</span>
                  <div className="input-group input-group-sm mb-2 col-pd-260 px-2">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      CEDULA/RIF:{" "}
                    </label>
                    <select
                      ref={cmbRif}
                      name="cmbrif"
                      disabled
                      className="form-select form-select-sm col-md-3 text-center"
                      aria-label=".form-select-sm example"
                    >
                      <option value="">--</option>
                      {cmbCedula &&
                        cmbCedula.map((item, index) => (
                          <option key={index} value={item}>
                            {item}
                          </option>
                        ))}
                    </select>
                    <input
                      ref={txtRif}
                      autoComplete="off"
                      disabled
                      maxLength={9}
                      type="text"
                      className="form-control fs-6"
                      name="cedula"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                  <div className="input-group input-group-sm mb-2 col-pd-340 px-0">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      NOMBRE:{" "}
                    </label>
                    <input
                      disabled
                      autoComplete="off"
                      type="text"
                      className="form-control fs-6"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      defaultValue={nomCliente}
                    />
                  </div>
                  <div className="input-group input-group-sm mb-2 col-md-12">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      DIRECCION:{" "}
                    </label>
                    <input
                      disabled
                      autoComplete="off"
                      type="text"
                      className="form-control fs-6"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      defaultValue={dirCliente}
                    />
                  </div>
                </div>
              </div>

              <div
                className="colfull1070 colfull40p mx-auto mb-1 row m-0"
                style={{ fontSizeAdjust: "0.6" }}
              >
                <div className="col-md-12 mx-auto row mb-1 py-2 border-azul rounded ">
                  <span className="fw-bold mb-1">Datos del Vendedor</span>
                  <div className="input-group input-group-sm mb-2 col-pd-230 px-2">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      CEDULA/RIF:{" "}
                    </label>
                    <input
                      disabled
                      autoComplete="off"
                      type="text"
                      className="form-control fs-6"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      defaultValue={cedRif}
                    />
                  </div>
                  <div className="input-group input-group-sm mb-2 col-md-12">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      NOMBRE:{" "}
                    </label>
                    <input
                      disabled
                      autoComplete="off"
                      type="text"
                      className="form-control fs-6"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      defaultValue={nomVendedor}
                    />
                  </div>
                </div>
              </div>
              <div
                className="col-md-12 border-azul px-0 rounded"
                style={{ /*height: '230px',*/ backgroundColor: "#d5e9ff" }}
              >
                <TblContainer
                  container={{
                    height: 190,
                    width: "100%",
                    overflow: "auto",
                    padding: "2px",
                    fontSizeAdjust: "0.6",
                  }}
                >
                  <TblHead />
                  <TableBody className="overflow-hidden">
                    {records &&
                      records.map((item, index) => (
                        <TableRow key={index} style={{ padding: "0" }}>
                          <TableCell className="align-middle bg-light text-center p-0 d-flex">
                            <input
                              type="text"
                              style={{
                                borderBottomRightRadius: 0,
                                borderTopRightRadius: 0,
                                height: "37px",
                              }}
                              disabled
                              ref={(el) => (txtId.current[index] = el)}
                              className="form-control text-center form-control-sm bg-light fs-6"
                              defaultValue={item.codigo}
                            />
                          </TableCell>

                          <TableCell
                            className="align-middle bg-light text-start p-0 pl-2"
                            style={{ width: "260px" }}
                          >
                            {item.nombrecorto}
                          </TableCell>
                          <TableCell
                            className="align-middle bg-light text-center p-0"
                            style={{ width: "20px" }}
                          >
                            <input
                              type="text"
                              className="form-control form-control-sm bg-light text-right fs-6"
                              id="cantidad"
                              disabled
                              defaultValue={formatMoneda(
                                item.cantidad
                                  .toString()
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                              ref={(el) => (txtCantidad.current[index] = el)}
                              aria-label="Sizing example input"
                              aria-describedby="inputGroup-sizing-sm"
                            />
                          </TableCell>
                          <TableCell
                            className="align-middle bg-light text-end p-0 pr-2"
                            style={{ width: "70px" }}
                          >
                            {formatMoneda(
                              item.precio
                                .toString()
                                .replace(",", "")
                                .replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                          </TableCell>
                          <TableCell
                            className="align-middle bg-light p-0"
                            style={{ width: 70 }}
                          >
                            <select
                              className="form-control form-control-sm fs-6"
                              style={{ width: "100%" }}
                              disabled
                            >
                              {item.unidad &&
                                item.unidad.map((item2, x) => (
                                  <option key={x} value={item2.idunidad}>
                                    {" "}
                                    {item2.descripcion}{" "}
                                  </option>
                                ))}
                            </select>
                          </TableCell>
                          <TableCell
                            className="align-middle bg-light text-end p-0 pr-2"
                            style={{ width: "50px" }}
                          >
                            {formatMoneda(
                              item.iva
                                .toString()
                                .replace(",", "")
                                .replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                          </TableCell>
                          <TableCell
                            className="align-middle bg-light text-end p-0 pr-2"
                            style={{ width: "50px" }}
                          >
                            {formatMoneda(
                              item.montoiva
                                .toString()
                                .replace(",", "")
                                .replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                          </TableCell>
                          <TableCell
                            className="align-middle bg-light text-end p-0 pr-2"
                            style={{ width: "50px" }}
                          >
                            {formatMoneda(
                              item.total
                                .toString()
                                .replace(",", "")
                                .replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </TblContainer>
              </div>
              <div className="col-md-12 row m-0 px-0">
                <div className="col-md-7 py-1 mt-auto">
                  <div className="col-pd-botonesd row m-0 ml-auto"></div>
                </div>
                <div
                  className="col-md-5 border-azul rounded shadow"
                  style={{ backgroundColor: "#dbeeff" }}
                >
                  <div
                    className="input-group input-group-sm col-md-12"
                    style={{ fontSizeAdjust: "0.6" }}
                  >
                    <label
                      className="input-group-text bg-transparent border-0"
                      id="inputGroup-sizing-sm"
                      style={{ fontSize: 14 }}
                    >
                      SUBTOTAL: {moneda.simbolo}
                    </label>

                    <input
                      type="text"
                      disabled
                      ref={txtSubTotal}
                      value={formatMoneda(
                        totales.subtotal
                          .toString()
                          .replace(",", "")
                          .replace(".", ","),
                        ",",
                        ".",
                        2
                      )}
                      className="form-control bg-transparent text-right fw-bold rounded border-0 fs-5"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                  <div
                    className="input-group input-group-sm  col-md-12"
                    style={{ fontSizeAdjust: "0.6" }}
                  >
                    <label
                      className="input-group-text bg-transparent border-0"
                      id="inputGroup-sizing-sm"
                      style={{ fontSize: 14 }}
                    >
                      DESCUENTO: {moneda.simbolo}
                    </label>

                    <input
                      type="text"
                      disabled
                      ref={txtDescuento}
                      value={formatMoneda(
                        totales.descuento
                          .toString()
                          .replace(",", "")
                          .replace(".", ","),
                        ",",
                        ".",
                        2
                      )}
                      className="form-control bg-transparent text-right fw-bold rounded border-0 fs-5"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                  <div
                    className="input-group input-group-sm  col-md-12"
                    style={{ fontSizeAdjust: "0.6" }}
                  >
                    <label
                      className="input-group-text bg-transparent border-0"
                      id="inputGroup-sizing-sm"
                      style={{ fontSize: 14 }}
                    >
                      TOTAL IVA: {moneda.simbolo}
                    </label>

                    <input
                      type="text"
                      disabled
                      ref={txtTotIva}
                      value={formatMoneda(
                        totales.totaliva
                          .toString()
                          .replace(",", "")
                          .replace(".", ","),
                        ",",
                        ".",
                        2
                      )}
                      className="form-control bg-transparent text-right fw-bold rounded border-0 fs-5"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                  <div
                    className="input-group input-group-sm  col-md-12"
                    style={{ fontSizeAdjust: "0.6" }}
                  >
                    <label
                      className="input-group-text bg-transparent border-0"
                      id="inputGroup-sizing-sm"
                      style={{ fontSize: 14 }}
                    >
                      TOTAL: {moneda.simbolo}
                    </label>

                    <input
                      type="text"
                      disabled
                      ref={txtTotal}
                      value={formatMoneda(
                        totales.total
                          .toString()
                          .replace(",", "")
                          .replace(".", ","),
                        ",",
                        ".",
                        2
                      )}
                      className="form-control bg-transparent text-right fw-bold rounded border-0 fs-5"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                  <div
                    className="input-group input-group-sm  col-md-12"
                    style={{ fontSizeAdjust: "0.6" }}
                  >
                    <label
                      className="input-group-text bg-transparent border-0"
                      id="inputGroup-sizing-sm"
                      style={{ fontSize: 14 }}
                    >
                      ABONO: {moneda.simbolo}
                    </label>

                    <input
                      type="text"
                      disabled
                      ref={txtAbono}
                      className="form-control bg-transparent text-right fw-bold rounded border-0 fs-5"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                  <div
                    className="input-group input-group-sm  col-md-12"
                    style={{ fontSizeAdjust: "0.6" }}
                  >
                    <label
                      className="input-group-text bg-transparent border-0"
                      id="inputGroup-sizing-sm"
                      style={{ fontSize: 14 }}
                    >
                      SALDO: {moneda.simbolo}
                    </label>

                    <input
                      type="text"
                      disabled
                      ref={txtSaldo}
                      className="form-control bg-transparent text-right fw-bold rounded border-0 fs-5"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-sm btn-success rounded-pill"
          onClick={onChangeValidar}
          style={{ margin: "5px" }}
        >
          <i className="fas fa-check-circle"> Registrar Pago</i>{" "}
        </button>
        <button
          onClick={imprimirNotaEntrega}
          style={{ margin: "5px" }}
          className="btn btn-sm btn-primary rounded-pill"
          title="Imprimir Nota de Entrega"
        >
          <i className="fa fa-print"> Imprimir</i>
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
      <RegistrarPago
        show={mostrar}
        tipo={"notaentrega"}
        abonos={props.abono}
        esretenedor={esretencion}
        anticipo={props.anticipo}
        idvendedor={idVendedor}
        idfactu={idfact}
        numfactu={numfact}
        siescredit={actcredit}
        siesanticipo={actanticipo}
        idclient={idCliente}
        iva={xiva}
        montoiva={montoiva}
        ope={1}
        monto={monto}
        idmoned={moneda.idmoneda}
        onRenderizar={renderizar}
        onHideCancelar={() => {
          setMostrar(false);
        }}
      />
      <Dimmer active={activate} inverted>
        <Loader inverted>Cargando...</Loader>
      </Dimmer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </Modal>
  );
};
export default RegistrarPagoNotadeEntrega;



// WEBPACK FOOTER //
// ./src/components/finanzas/registrarPagoNotaEntrega.js